import { Stack, Typography } from '@mui/material';
import OrganisationUserListItem from './OrganisationUserListItem';
import { OrganisationUser } from './type';

/**
 * OrganisationUserList component displays a list of organisation users.
 * @param param0 - Props for the component
 * @returns JSX.Element
 */
export default function OrganisationUserList<T extends OrganisationUser>({
  users,
  onRemoveUser,
  ...props
}: {
  users: T[];
  AdditionalItem?: React.FC<T>;
  onRemoveUser: (user: T) => void;
}) {
  if (users.length === 0) {
    return (
      <Typography data-component="organisation-user-list-empty">No data available.</Typography>
    );
  }

  return (
    <Stack data-component="organisation-user-list" role="list">
      {users.map((user) => (
        <OrganisationUserListItem
          key={user.email}
          item={user}
          onRemoveUser={onRemoveUser}
          {...props}
        />
      ))}
    </Stack>
  );
}
